import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getAllWorkspacesData,
  Logger,
  workspacesSelector
} from '@futrli/shared-services';
import { useIntegrationsView } from '@futrli/views/hooks/useIntegrationsView';
import { WorkspacesListingItem } from '@futrli-sdk/workspaces';

import { StoreState } from '../../../core/redux-utils/types';

export const useLoadWorkspacesAndIntegrations = (workspaceId?: string | null, organisationId?: string | null) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const { errorLoading, integrations, isLoading: integrationsLoading } = useIntegrationsView();

  const { workspaces, workspace, organisation } = useSelector((state: StoreState) => {
    if (!workspaceId) {
      return {
        workspaces: null
      };
    }

    const { normalised } = state;
    const workspaces = workspacesSelector(normalised) as WorkspacesListingItem[];

    const workspace = workspaceId ? workspaces?.find(w => w.id === workspaceId) : undefined;
    const organisation = organisationId ? workspace?.organisations?.find(o => o.id === organisationId) : undefined;

    return { workspaces, workspace, organisation };
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        await dispatch(getAllWorkspacesData());
      } catch (e) {
        Logger.error(e as string);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dispatch]);

  useEffect(() => {
    if (errorLoading) {
      Logger.error(errorLoading.message);
    }
  }, [errorLoading]);

  return {
    workspaces,
    workspace,
    organisations: workspace?.organisations,
    organisation,
    integrations: workspaceId ? integrations ?? null : null,
    isLoading: isLoading || integrationsLoading
  };
};
